<template>
  <div class="login-wrap">
    <!--登录头部-->
    <div class="login-header">
      <!-- <img class="logo" src="../assets/in.svg" alt=""> -->
      <div class="title-logo">
        <span class="company-name">广西供应链服务集团-数字化物产云大数据平台</span>
        <span
          style="color: #f00; font-size: 50px; position: absolute; top: 6px; margin-left: 5px"
          >{{ envName }}</span
        >
      </div>
      <!--国际化-->
      <!-- <div class="title-container">
        <img class="title-container-img" src="../assets/language.svg" alt="" />
        <lang-select class="set-language" />
      </div> -->
    </div>

    <div class="ms-login">
      <div class="login-content">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="0px"
          class="ms-content"
        >
          <div class="input-box">
            <div class="name">{{ $t('login.username') }}</div>
            <div class="input">
              <img class="user" src="../assets/user.svg" alt="" />
              <el-form-item prop="username">
                <el-input v-model.trim="ruleForm.username" size="medium" maxlength="32" />
              </el-form-item>
            </div>
          </div>
          <div class="input-box">
            <div class="name">{{ $t('login.password') }}</div>
            <div class="input">
              <img
                class="pass-word"
                src="../assets/passWord.svg"
                alt=""
                style="padding-right: 13px"
              />
              <el-form-item prop="password">
                <el-input
                  v-model.trim="ruleForm.password"
                  ref="password"
                  size="medium"
                  :type="passwordType"
                  maxlength="32"
                />
                <span class="show-pwd" @click="showPwd">
                  <img v-if="passwordType === 'password'" src="../assets/eyes.svg" alt="" />
                  <img v-else src="../assets/see-eyes.svg" alt="" />
                </span>
              </el-form-item>
            </div>
          </div>
          <div class="input-box">
            <div class="name">{{ $t('login.verificationCode') }}</div>
            <div class="verification-code">
              <div class="key-input">
                <img class="key" src="../assets/key.svg" alt="" />
                <el-form-item prop="imageCode" class="valiateCode">
                  <el-input
                    v-model="ruleForm.imageCode"
                    class="code-width"
                    @keyup.enter.native="submitForm('ruleForm')"
                  />
                </el-form-item>
              </div>
              <img :src="imgUrl" class="code-img-width" @click="getValidateCode" />
            </div>
          </div>
          <div class="login-btn">
            <el-button @click.stop="submitForm('ruleForm')">{{ $t('login.logIn') }}</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import API from '../api/login';
  import { isMobile } from '@/utils';
  export default {
    data: function () {
      return {
        passwordType: 'password',
        load: false,
        ruleForm: {
          username: '',
          password: '',
          imageCode: '',
          deviceId: '',
        },
        imgUrl: '',
        deviceId: '',
        envName: '',
      };
    },
    computed: {
      isMobileFlag() {
        return isMobile();
      },
      rules() {
        return {
          username: [
            {
              required: true,
              message: this.$t('login.usernameNotEmpty'),
              trigger: 'blur',
            },
          ],
          password: [
            {
              required: true,
              message: this.$t('login.passwordNotEmpty'),
              trigger: 'blur',
            },
          ],
          imageCode: [
            {
              required: true,
              message: this.$t('login.verificationNotEmpty'),
              trigger: 'blur',
            },
          ],
        };
      },
    },
    created: function () {
      // 获取字典
      this.$baseRequest.getAllDictMap();
      this.getValidateCode();
      this.envName = process.env.NODE_ENV == 'production' ? '' : `${process.env.NODE_ENV}环境`;
    },
    methods: {
      showPwd() {
        if (this.passwordType === 'password') {
          this.passwordType = '';
        } else {
          this.passwordType = 'password';
        }
        this.$nextTick(() => {
          this.$refs.password.focus();
        });
      },
      // 登录
      submitForm(formName) {
        if (!this.load) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              let params = JSON.parse(JSON.stringify(this.ruleForm));
              params.password = this.Base64.encode(params.password);
              this.load = true;
              this.loading.startLoading();
              this.$axios.post(API.LOGIN_API, params).then((res) => {
                this.$globalVar.refreshTokenFlag = 0; //初始化刷新token标识
                this.load = false;
                if (res.data.code === 0) {
                  const user = {
                    // 是否是权限系统账号 1是2否
                    isAuth: res.data.data.isAuth,
                    access_token: res.data.data.token.access_token,
                    applicationCode: '',
                    account: res.data.data.user.account || '',
                    // 账号名称
                    userName: res.data.data.user.userName || res.data.data.user.tenantName,
                    // personName
                    personName: res.data.data.user.personName,
                    // 账号id
                    userCode: res.data.data.token['X-AUTH-UserId'],
                    // 账号是否是管理员
                    adminFlag: res.data.data.user.adminFlag || '',
                    // 公司编码
                    companyCode: '',
                    // 公司名称
                    companyName: '',
                    // 部门编码
                    departmentCode: '',
                    // 部门名称
                    departmentName: '',
                    // 租户code
                    tenantCode: res.data.data.user.tenantCode || '',
                    // 租户名称
                    tenantName: res.data.data.user.tenantName || '',
                    inoutFlag: res.data.data.user.inoutFlag || '',
                    password: params.password,
                    personNo: res.data.data.user.personNo,
                    // 时间戳
                    expir: res.data.data.expir,
                    // 刷新token
                    refresh_token: res.data.data.token.refresh_token,
                  };
                  // if(Base64.decode(params.password)!=res.data.data.personNo){
                  //    delete user.password
                  // }
                  this.$store.commit('saveUserInfo', user);
                  this.$store.dispatch('tagsView/delAllViews');
                  // 如果是登录权限系统账号不需要选择应用
                  if (res.data.data.isAuth === '1') {
                    this.$store.dispatch('menu/setIndexType', '');
                    this.loading.endLoading();
                    this.$router.push('/dashboard');
                  } else {
                    // 获取应用列表
                    this.getApplication(user);
                    // 获取详情按钮权限
                    this.getRoleOtherButton(user);
                  }
                } else {
                  this.loading.endLoading();
                  this.getValidateCode();
                  this.ruleForm.imageCode = '';
                  // 如果有错误返回，提示信息
                  this.$alert(res.data.msg);
                }
              });
            }
          });
        }
      },
      // 获取应用列表
      getApplication(user) {
        const params = {};
        this.$axios.get(API.GET_APPLICATION_LIST_API + '/' + user.userCode, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            //当前涉及到多应用  多菜单全局中定义固定应用code
            user.applicationCode = this.$globalVar.applicationCode[0];
            this.$store.commit('saveUserInfo', user);
            if (this.isMobileFlag) {
              this.$router.push('/property/meterRegistration');
            } else {
              this.$router.push('/dashboard');
            }
            /* if (res.data.data.length === 1) {
              user.applicationCode = res.data.data[0].applicationCode;
              this.$store.commit("saveUserInfo", user);
              this.$router.push("/dashboard");
            } else {
              // TODO
              this.$alert("该功能暂未开发，敬请期待。");
            } */
          } else {
            // 如果有错误返回，提示信息
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取详情按钮权限
      getRoleOtherButton(user) {
        this.$axios
          .post(API.GET_ROLE_OTHER_BUTTON + '?USER_ACCOUNT=' + user.account)
          .then((res) => {
            if (res.data.code === 0) {
              this.$store.dispatch('authCode/setAuthCode', res.data.data);
            } else {
              // 如果有错误返回，提示信息
              this.$alert('获取按钮权限失败：' + res.data.msg);
              this.$router.push('/login');
            }
          });
      },
      // 获取验证码
      getValidateCode() {
        this.$axios.post(API.VALIDATE_CODE_API).then((res) => {
          if (res.data.code === 0) {
            sessionStorage.deviceId = res.data.data.deviceId;
            this.ruleForm.deviceId = res.data.data.deviceId;
            this.imgUrl = 'data:image/jpg;base64,' + res.data.data.image;
          } else {
            // 如果有错误返回，提示信息
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  $bg: #fff;
  $light_gray: #fff;
  $cursor: #fff;
  $maintheme: #409eff;

  .login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../assets/bg.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .login-header {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      // .logo{
      //   width: 150px;
      //   height: 30px;
      //   margin: 40px 0 0 60px;
      // }
    }
    .title-logo {
      text-indent: 0px;
      padding: 40px 0 0 60px;
      font-size: 24px;
      font-weight: bold;
      color: #fff;
    }
    .title-container {
      float: right;
      height: 30px;
      line-height: 30px;
      padding-top: 44px;
      padding-right: 60px;
      text-align: center;
      ::v-deep .el-dropdown-link {
        font-size: 14px;
      }
      .set-language {
        font-size: 14px;
        cursor: pointer;
      }
      .title-container-img {
        vertical-align: text-bottom;
        line-height: 24px;
        height: 24px;
        width: 24px;
        padding-right: 10px;
      }
    }

    .ms-login {
      position: absolute;
      right: 14%;
      top: 30%;
      width: 360px;
      border-radius: 5px;
      overflow: hidden;
    }
    .show-pwd {
      position: absolute;
      right: 10px;
      top: 2px;
      font-size: 16px;
      cursor: pointer;
      user-select: none;
      img {
        width: 22px;
        height: 18px;
        vertical-align: middle;
      }
    }
    .login-btn {
      text-align: center;
    }
    .login-btn button {
      width: 100%;
      height: 50px;
      margin-top: 30px;
      border-radius: 8px;
      background-color: $maintheme;
      border-color: $maintheme;
      color: #ffffff;
      font-size: 16px;
    }
  }
  /**登录*/
  .ms-content {
    background: rgba(255, 255, 255, 0.8);
    padding: 20px;
    ::v-deep .el-form-item__error {
      font-size: 14px;
      top: 140%;
      left: 25%;
    }
    .verification-code {
      ::v-deep .el-form-item__error {
        left: 0%;
      }
    }
    .input-box {
      padding-bottom: 20px;
      .name {
        font-size: 14px;
        // color: #ffffff;
      }
      .input {
        padding-left: 20px;
        display: flex;
        align-items: center;
        line-height: 48px;
        height: 48px;
        .user {
          width: 25px;
          height: 22px;
          vertical-align: middle;
          padding-right: 15px;
        }
        .pass-word {
          width: 28px;
          height: 28px;
          padding-right: 15px;
        }
        border-bottom: 2px solid #409eff;
      }
      .verification-code {
        display: flex;
        .key-input {
          display: flex;
          align-items: center;
          border-bottom: 2px solid #409eff;
          margin-right: 5%;
          .key {
            width: 25px;
            height: 14px;
            vertical-align: middle;
            padding-right: 15px;
            padding-left: 20px;
          }
          .code-width {
            width: 80%;
          }
        }
        .code-img-width {
          width: 42%;
          height: 40px;
          vertical-align: bottom;
          border-radius: 8px;
        }
      }
    }
    // ::v-deep .el-input__inner {
    //   border: none;
    //   border-radius: 0px;
    //   background: transparent;
    //   color: #ffffff;
    //   font-size: 14px !important;
    // }
    .el-form-item {
      width: 100%;
      margin-bottom: 0;
    }
    .el-input__icon {
      font-size: 18px;
      width: 19px;
      height: 21px;
    }
    .el-input__prefix,
    .el-input__suffix {
      line-height: 32px;
      width: 25px;
    }
  }
</style>
<style lang="scss">
  .login-content {
    .el-input--small .el-input__inner {
      padding-left: 20px !important;
    }
  }
  .ms-message {
    width: 100%;
    position: absolute;
    color: white;
    font-size: 14px;
    bottom: 5%;
    text-align: center;
  }
</style>
